import {useLayoutEffect, useState} from 'react';
import {createPortal} from 'react-dom';

// add child below to root div
function createWrapperAndAppendToBody(wrapperId) {
  const wrapperElement = document.createElement('div');
  wrapperElement.setAttribute('id', wrapperId);
  document.body.appendChild(wrapperElement);
  return wrapperElement;
}

function ReactPortal({children, wrapperId = 'modal'}) {
  const [wrapperElement, setWrapperElement] = useState(null);

  useLayoutEffect(() => {
    let element = document.getElementById(wrapperId);
    let isContainerCreated = false;

    if (!element) {
      element = createWrapperAndAppendToBody(wrapperId);
      isContainerCreated = true;
    }
    setWrapperElement(element);

    return () => {
      // delete the programatically created element
      if (isContainerCreated && element.parentNode) {
        element.parentNode.removeChild(element);
      }
    };
  }, [wrapperId]);

  if (!wrapperElement) return null;

  return createPortal(children, document.getElementById(wrapperId));
}

export default ReactPortal;
